import { render, staticRenderFns } from "./hy.vue?vue&type=template&id=cc367a9c&scoped=true&"
var script = {}
import style0 from "./hy.vue?vue&type=style&index=0&id=cc367a9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc367a9c",
  null
  
)

export default component.exports